import styled from "styled-components";

export const Container = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(
    0deg,
    rgba(139, 127, 127, 1) 0%,
    rgba(208, 209, 211, 1) 100%
  );
`;

export const Wrapper = styled.div`
  border: 1px solid #000000;
  border-radius: 5px;
  width: 50vw;
  padding: 10px;
  background-color: #fff;
`;

export const StyledLogo = styled.img`
  display: block;
  width: 20vw;
  margin: 0 auto;
`;

export const Title = styled.h1`
  text-align: center;
  margin: 10px 0;
  font-size: 24px;
  font-weight: 600;
`;

export const SubTitle = styled.h2`
  text-align: center;
  margin: 0px;
  font-size: 16px;
  font-weight: normal;
`;

export const StyledForm = styled.div`
  width: 80%;
  margin: 20px auto;

  .MuiFormControl-root {
    margin-top: 20px;
  }
`;

export const Footer = styled.div`
  margin-top: 20px;
  text-align: right;
  button {
    width: 120px;
  }
`;
